import { Component, Input } from '@angular/core';

import { FormControlComponent } from '@forms/form-control/form-control.component';

@Component({
  selector: 'rav-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss']
})
export class TextareaComponent extends FormControlComponent {
  @Input() height = 5;
  constructor() {
    super();
  }
}
